import { RoutesMaker } from "./interfaces/navigation.interface";

export const makeRoutes: RoutesMaker = (
    routerConfig,
    interceptor = routerConfig => routerConfig,
    session
) =>
    interceptor(routerConfig, session)
    .map(routeItem => routeItem.route);